import React, { memo, useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import Paper from "@material-ui/core/Paper/Paper";
import NotificationsList from "../List";
import Badge from "@material-ui/core/Badge/Badge";
import notificationApi from "@api/notification";
import { notification } from "@core/helper/notificationHelper";
import { Popover } from "@material-ui/core";
import clsx from "clsx";
import { UpdateSettingContext } from "@context/UpdateSettingProvider";

const NotificationHeaderBadge = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [unReadNotifCount, setUnReadNotifCount] = useState(0);
  const open = Boolean(anchorEl);
  const UpdateSetting = useContext(UpdateSettingContext);

  useEffect(() => {
    notificationApi
      .getUnreadNotificationsCount()
      .then((data) => {
        setUnReadNotifCount(data);
      })
      .catch((data) => {
        notification(
          "",
          "danger",
          !!data && !!data?.message ? data?.message : "SERVER ERROR"
        );
      });
  }, [UpdateSetting.updateNotification]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <div onClick={handleClick}>
        {open ? (
          <span className={clsx("icon-x", classes.icon)} />
        ) : (
          <Badge badgeContent={unReadNotifCount} color="error">
            <span className={clsx("icon-bell", classes.icon)} />
          </Badge>
        )}
      </div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: 80, left: 172 }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Paper className={classes.paper} elevation={0}>
          <NotificationsList setAnchorEl={setAnchorEl} />
        </Paper>
      </Popover>
    </div>
  );
};

export default memo(NotificationHeaderBadge);
